export const GET_FAVORITES_URL = 'r/menu/user/v1/favorite/';
